import React, { useRef } from "react";
import AboutUsIntro from "../aboutus/intro-section/AboutUsIntro"
import OurMissionSection from "../aboutus/our-mission-section/OurMissionSection"
import CustomerJourneySection from "./customer-journey-section/CustomerJourneySection";
import ContactFloatingIcons from "./contact-floating-icons/ContactFloatingIcons";
import ASICVerificationHighlights from "./asic-verification-higlights/ASICVerificationHighlights";

const AboutUs = () => {
  return (
    <div>
        <AboutUsIntro />
        <OurMissionSection />
        <CustomerJourneySection />
        <ContactFloatingIcons />
        <ASICVerificationHighlights />
    </div>
  );
};

export default AboutUs;